import { DEFAULT_ADVERTISER_AGENCY_ID, DEFAULT_INNER_CAMPAIGN_ADVERTISER_AGENCY_ID } from '../../../utils/constants';
import { UserRoleE } from './../../../models/enums';

const calcAdvertisingAgencyId = (role: UserRoleE, userId: number): number => {
    switch (role) {
        case UserRoleE.Broadcaster: return +DEFAULT_INNER_CAMPAIGN_ADVERTISER_AGENCY_ID;
        case UserRoleE.GlobalAdmin:
        case UserRoleE.GlobalAdminAndAdminContentManager: return DEFAULT_ADVERTISER_AGENCY_ID;
        default: return userId;
    }
};

export default calcAdvertisingAgencyId;